import { F } from './fancybox-Bnoh7Aed.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class ProductMedia extends HTMLElement {
  #mediaItems = [...this.querySelectorAll('.product-media-item')];
  #thumbSwiper;
  #swiper;
  #unsubscribers = [];

  async connectedCallback() {
    await this.#initThumbSwiper();
    await this.#initSwiper();
    this.initFancybox();

    this.#unsubscribers.push(
      PubSub.subscribe('variant:change', ({ mediaId }) => this.#slideToMatchingMedia(mediaId))
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  async #initSwiper() {
    if (this.#mediaItems.length <= 1) return;

    try {
      const { Swiper } = await import('./swiper-YSyQLWy6.js');
      const { Thumbs, Navigation } = await import('./index-DPDZa3KK.js');

      this.#swiper = new Swiper('.swiper--media', {
        modules: [Thumbs, Navigation],
        spaceBetween: 0,
        initialSlide: this.querySelector('.initial-slide').dataset.productMediaIndex,
        breakpoints: {
          1024: {
            spaceBetween: 16,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: this.#thumbSwiper,
        },
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  async #initThumbSwiper() {
    if (this.#mediaItems.length <= 1) return;

    try {
      const { Swiper } = await import('./swiper-YSyQLWy6.js');

      this.#thumbSwiper = new Swiper('.swiper--thumbs', {
        direction: 'vertical',
        spaceBetween: 16,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        autoHeight: true,
      });
    } catch (error) {
      console.error('Error initializing thumb Swiper:', error);
    }
  }

  #slideToMatchingMedia(mediaId) {
    if (!mediaId) return;

    const mediaItem = this.#mediaItems.find((item) => item.dataset.productMediaId === mediaId);
    const mediaSlide = mediaItem.closest('.swiper-slide');
    if (mediaSlide) {
      this.#swiper.slideTo(mediaSlide.dataset.productMediaIndex);
    }
  }

  initFancybox() {
    F.bind('[data-fancybox]', {
      // used to fix the out of sync slides issue
      placeFocusBack: false,
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }
}

customElements.define('product-media', ProductMedia);
